import {  baseThunk } from '../../fetch/basicThunk';
import { QUERY_DELETE_DELETECUSTOMER, QUERY_GET_CUSTOMERS,QUERY_GET_CUSTOMERSPAG,QUERY_POST_CREATECUSTOMER,QUERY_PUT_EDITCUSTOMER,QUEY_GET_MASTER_COUNT } from '../../fetch/constantQueries';

export const getCustomerList = baseThunk("customer/list", QUERY_GET_CUSTOMERS, "GET");
export const getCustomersPag = baseThunk(`customer/listPag`, QUERY_GET_CUSTOMERSPAG, "GET");
export const getCustomerCount = baseThunk("customer/postCustomerCount",QUEY_GET_MASTER_COUNT,"GET");

export const createCustomer = baseThunk("customer/create", QUERY_POST_CREATECUSTOMER, "POST");
export const deleteCustomer = baseThunk("customer/delete", QUERY_DELETE_DELETECUSTOMER, "DELETE");
export const editCustomer = baseThunk("customer/dupdate", QUERY_PUT_EDITCUSTOMER, "PUT");